import { Textarea } from "design-system/atoms/Textarea"
import { VariableAutocomplete } from "design-system/molecules/VariableAutocomplete"
import { cn } from "design-system/utils"
import { ReactElement } from "react"
import { useTranslation } from "react-i18next"
import { Errors, WhatsappTemplateBodySchema } from "schema"

const MAX_LENGTH_TEMPLATE = 1024

type WhatsappTemplateTextareaProps = {
  value: string
  onChange: (text: string) => void
  showErrorMessage?: boolean
  children?: ReactElement
} & Omit<React.ComponentProps<"textarea">, "onChange">

export const WhatsappTemplateTextarea = ({
  onChange,
  value,
  showErrorMessage = true,
  children,
  ...props
}: WhatsappTemplateTextareaProps) => {
  const { t } = useTranslation()
  const validation = WhatsappTemplateBodySchema.safeParse(value)
  const hasError = !validation.success

  return (
    <div>
      <div className="relative">
        <VariableAutocomplete
          variables={[
            { label: "name", value: "name" },
            { label: "companyName", value: "company_name" },
          ]}
          className="w-full"
          noSpaces
        >
          <Textarea
            {...props}
            value={value}
            onChange={(ev) => onChange(ev.target.value)}
            className={cn("relative pb-12", hasError && "ring ring-destructive", props.className)}
            maxLength={MAX_LENGTH_TEMPLATE}
          />
        </VariableAutocomplete>
        {children}
      </div>
      {hasError && showErrorMessage && (
        <span className="text-destructive text-xs">
          {t(`errors.${Errors.WHATSAPP_TEMPLATE_VARIABLE_AT_EDGE}`)}
        </span>
      )}
    </div>
  )
}
